import { render, staticRenderFns } from "./hotel-list.vue?vue&type=template&id=967507ce"
import script from "./hotel-list.vue?vue&type=script&lang=ts"
export * from "./hotel-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports